import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchLeagues } from '../../../api/leagues';
import { APIS, SPORTS } from '../../../utils/constants';
import ManageFieldsDialog from '../manageFieldsDialog';

const leagueParams = [
  { key: 'sportId', value: SPORTS.CRICKET },
  { key: 'source', value: APIS.INTERNAL },
];

const ManageCompetitionDialogWrapper = ({ open, onConfirm, onClose, competition }) => {
  const [leagues, setLeagues] = useState([]);

  const fetchLeagueList = useCallback(async () => {
    const res = await fetchLeagues(leagueParams);
    setLeagues(res.data);
  }, []);

  useEffect(() => {
    if (open) {
      fetchLeagueList();
    }
  }, [open, fetchLeagueList]);

  const data = useMemo(
    () =>
      competition
        ? { ...competition, customName: competition.customName ?? '' }
        : { name: '', leagueId: '', customName: '' },
    [competition]
  );

  const fields = useMemo(
    () => [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'customName', label: 'Custom name', type: 'text', required: false },
      {
        name: 'leagueId',
        label: 'League',
        type: 'autocomplete',
        readonly: !!competition,
        options: leagues.map((l) => ({ label: l.name, value: l.id })),
      },
    ],
    [competition, leagues]
  );

  return (
    <ManageFieldsDialog
      open={open}
      onConfirm={onConfirm}
      onClose={onClose}
      data={data}
      fields={fields}
      title="New competition"
    />
  );
};

export default ManageCompetitionDialogWrapper;
